import Phaser from 'phaser';
import config from './main/game-config';

const launch = () => {
  const game = new Phaser.Game(config);
  if (!game.device.os.desktop) game.input.mouse.enabled = false;
  return game;
};
export { launch };
